import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../axiosInterceptor";
import { Sizemultiselect } from "../../../Components/Labels";
import { AttributeInput } from "../../../Components/AttributeInputType";
import TagsInput from "react-tagsinput";
import ProductImageUploader from "./components/ProductImageUploader";
import Select from "react-select";
import {
  AttributeStructuredata,
  fetchAllData,
} from "../../../helper/ProductAttributeHandling";
import Upload from "../../../Components/upload";
const CataloueProductUpdate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { catalogueData, id, product_id } = location.state || {};
  const [brands, setBrands] = useState([]);
  const [sizedata, setsizedata] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [updateData, setUpdatedata] = useState({});
  const [attributes,setAttributes]=useState([])
    const [keywords, setkeywords] = useState([])
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (product_id) {
          await fetchAllData(
            `/productdetail/${product_id}`,
            setUpdatedata
          );
        }
        const [sizeRes, brandRes,attributes] = await Promise.all([
          axiosInstance.get("/size"),
          axiosInstance.get("/brand"),
           axiosInstance.get("/attribute-children")
        ]);
        setsizedata(sizeRes.data.data || []);
         setAttributes(attributes.data.data || [])
        setBrands(
          (brandRes.data.data || []).map((brand) => ({
            value: brand.id,
            label: brand.name,
          }))
        );
      } catch (error) {
        return error;
      }
    };
    fetchData();
  }, []);

  const initialValues = {
    name: "",
    sku: "",
    quantity: 0,
    weight: 0,
    stitching: catalogueData?.optionType === "stitching",
    retail_price: 0,
    average_price: catalogueData?.average_price || 0,
    retail_discount: 0,
    offer_price: 0,
    description: "",
    tag: [],
    catalogue_id: id,
    relatedProduct: [],
    sizes: catalogueData?.sizes || [],
    showInSingle: catalogueData?.showInSingle,
    category_id: catalogueData?.categoriesId || [],
    attributes: [],
    images: [],
    meta_title: "",
    meta_keyword: "",
    video:"",
    meta_description: "",
    optionType: catalogueData?.optionType || "",
    brandIds: catalogueData?.brand_id || [],
    postId:null,
  };
  const {
    values,
    errors,
    setFieldValue,
    touched,
    handleChange,
    handleSubmit,
    isSubmitting
  } = useFormik({
    initialValues,
    onSubmit: async (values) => {
      try {
        values.attributes = selectedValues;
        const id = updateData?.id
        const response = await axiosInstance.put(`catalogue-product/${id}`, values);
        const { message } = response?.data
        toast.success(message);
        navigate(-1)

      } catch (error) {
        toast.error(error?.response?.data?.message);
        return error;
      }
    },
  });


  const handleInputChange = (key, value) => {
    setSelectedValues((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  };
  const onSave = (key, selectedValues) => {
    setSelectedValues((prevValues) => ({
      ...prevValues,
      [key]: selectedValues,
    }));
  };

  const handleOfferPrice = (event) => {
    const { name, value } = event.target;
    handleChange(event);

    let retailPrice = parseFloat(values.retail_price) || 0;
    let discount = parseFloat(values.retail_discount) || 0;

    if (name === "retail_price") {
      retailPrice = parseFloat(value) || 0;
    } else if (name === "retail_discount") {
      discount = parseFloat(value) || 0;
    }
    let offerPrice = retailPrice || 0;
    if (discount > 0) {
      offerPrice = (retailPrice - (retailPrice * discount) / 100).toFixed(2);
    }
    setFieldValue("offer_price", offerPrice);
  };

  useEffect(() => {
    if (updateData && updateData?.id) {
      setFieldValue("name", updateData?.name);
      setFieldValue("sku", updateData?.sku);
      setFieldValue("retail_price", updateData?.retail_price || 0);
      setFieldValue("retail_discount", updateData?.retail_discount || 0);
      setFieldValue("offer_price", updateData?.offer_price || 0);
      setFieldValue("average_price", catalogueData?.average_price || updateData?.average_price || 0);
      setFieldValue("quantity", updateData?.quantity || 0);
      setFieldValue("weight", updateData?.weight || 0);
      setFieldValue("description", updateData?.description);
      setFieldValue("tag", updateData?.tag);
      setFieldValue("relatedProduct", updateData?.relatedProducts || []);
      setFieldValue("meta_title", updateData?.meta_title);
      setFieldValue("meta_keyword", updateData?.meta_keyword);
      setFieldValue("meta_description", updateData?.meta_description);
      setFieldValue("retail_GST", updateData?.retail_GST);
      setFieldValue("attributes", updateData?.attributeValues);
      setFieldValue("showInSingle", catalogueData?.selection || updateData?.showInSingle);
      setFieldValue("sizes", updateData?.sizes);
      setFieldValue("video",updateData?.video)
      setkeywords(updateData.search_keywords)
      setFieldValue("postId", updateData?.instagramVideo?.[0]?.postId || null);
      //  setFieldValue("sizes", updateData?.sizes?.lenght > 0 ?  updateData?.sizes : catalogueData?.sizes);
      const combinedImages = (updateData?.image || []).map((original, index) => ({
        original,
        thumbImage: updateData?.thumbImage?.[index] || "",
        mediumImage: updateData?.mediumImage?.[index] || ""
      }));
      setFieldValue("images", combinedImages);
      setFieldValue("brandIds", updateData?.ProductBrand?.map(b => b.brand_id) || []);
      setFieldValue("optionType", catalogueData?.optionType || updateData.optionType);
      if (updateData?.catalogue_id) {
        setFieldValue("catalogue_id", id || updateData?.catalogue_id);
      }
      const categoriesId =
        updateData?.categories &&
        updateData?.categories?.map((item) => item?.category_id);
      setFieldValue("category_id", categoriesId);

      if (
        updateData?.attributes &&
        Array.isArray(updateData?.attributes) &&
        updateData?.attributes?.length > 0
      ) {
        const transformedData = AttributeStructuredata(updateData?.attributes);
        setSelectedValues(transformedData);
      }
    }
  }, [updateData, catalogueData]);

  return (
    <div className="content-wrapper">
      <div className="page-header mt-5">
        <h3 className="page-title">Update Catalogue Product</h3>

      </div>

      <div className=" rounded bg-white px-4 pt-4 pb-2 mb-3 shadow-s">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="form-group">
                <label className="col-form-label ">Name</label>
                <input
                  className="form-control form-control-sm"
                  type="text"
                  id="name"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                />

                {touched.name && errors.name && (
                  <small className="text-danger">{errors.name}</small>
                )}
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="form-group">
                <label className="col-form-label ">SKU</label>
                <input
                  className="form-control form-control-sm"
                  type="text"
                  id="sku"
                  name="sku"
                  value={values.sku}
                  onChange={handleChange}
                />

                {touched.sku && errors.sku && (
                  <small className="text-danger">{errors.sku}</small>
                )}
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="form-group">
                <label className="col-form-label ">Weight</label>
                <div className="input-group">
                  <input
                    className="form-control form-control-sm"
                    type="number"
                    id="weight"
                    name="weight"
                    value={values.weight}
                    onChange={handleChange}
                  />
                </div>

                {touched.weight && errors.weight && (
                  <small className="text-danger">{errors.weight}</small>
                )}
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="form-group">
                <label className="col-form-label ">Quantity</label>
                <div className="input-group">
                  <input
                    className="form-control form-control-sm"
                    type="number"
                    id="quantity"
                    name="quantity"
                    value={values.quantity}
                    disabled={catalogueData?.optionType === "stitching"}
                    onChange={handleChange}
                  />
                </div>
                {touched.quantity && errors.quantity && (
                  <small className="text-danger">{errors.quantity}</small>
                )}
              </div>
            </div>

          

                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label className="col-form-label ">Price</label>
                    <div className="input-group">
                      <input
                        className="form-control form-control-sm"
                        type="number"
                        id="retail_price"
                        name="retail_price"
                        value={values.retail_price}
                        onChange={(e) => {
                          const value = e.target.value;
                          setFieldValue("offer_price", value);
                          handleChange(e);
                        }}
                      />
                    </div>

                    {touched.retail_price && errors.retail_price && (
                      <small className="text-danger">{errors.retail_price}</small>
                    )}
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label className="col-form-label ">Discount</label>
                    <div className="input-group">
                      <input
                        className="form-control form-control-sm"
                        type="number"
                        id="retail_discount"
                        name="retail_discount"
                        value={values.retail_discount}
                        onChange={(e) => {
                          handleOfferPrice(e);
                        }}
                      />
                    </div>
                    {touched.retail_discount && errors.retail_discount && (
                      <small className="text-danger">{errors.retail_discount}</small>
                    )}
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label className="col-form-label ">Offer Price</label>
                    <div className="input-group">
                      <input
                        className="form-control form-control-sm"
                        type="number"
                        id="offer_price"
                        name="offer_price"
                        value={values.offer_price}
                        readOnly
                      />
                    </div>

                    {touched.offer_price && errors.offer_price && (
                      <small className="text-danger">{errors.offer_price}</small>
                    )}
                  </div>
                </div>
             

            {attributes &&
              attributes?.length > 0 &&
              attributes?.map((attribute) => {
                return (
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label className="col-form-label ">{attribute?.name}</label>
                      <AttributeInput
                        attribute={attribute}
                        selectedValues={selectedValues || ""}
                        onSave={onSave}
                        handleInputChange={handleInputChange}
                      />
                    </div>
                  </div>
                );
              })}

            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="form-group">
                <label className="col-form-label ">Related Product</label>
                <TagsInput
                  value={values.relatedProduct}
                  onChange={(newTags) => setFieldValue("relatedProduct", newTags)}
                 inputProps={{
    placeholder: "",
  }}
                />
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="form-group">
                <label>Brands</label>

                <Select
                  isMulti
                  options={brands}
                  value={brands.filter((brand) =>
                    values?.brandIds?.includes(brand.value)
                  )}
                  onChange={(selectedOptions) => {
                    const ids = selectedOptions.map((opt) => opt?.value);
                    setFieldValue("brandIds", ids);
                  }}
                />
              </div>
            </div>

            <div className="col-lg-12 col-md-6 col-sm-12 mt-2">
             <div className="form-group">
              <label>Images</label>
              <small className="form-text ">
              Required image size: 750px × 1125px (.png, .jpg, .jpeg, .webp)
             </small>
              <ProductImageUploader
                initialImages={values.images}
                onUploadComplete={(allImages) => {
                  setFieldValue("images", allImages);
                }}
              />
             </div>
            </div>

             <div className="col-lg-12 col-md-6 mt-4">
                                                         <div className="form-group">
                                                          <label className="col-form-label ">Video (Optional)</label>
                                                        <small className="form-text ">
                                                          Maximum Sizes 7MB
                                                        </small>
                                                                  <Upload
                                                                    label="image-video"
                                                                    initialImage={values.video}
                                                                    //  onChange={(urls) => handleFormChange(index, "video", urls)}
                                                                    onChange={(imgUrl) => setFieldValue("video", imgUrl)}
                                                                    apiUrl={"uploads?label=product"}
                                                    
                                                                  />
                                                         </div>
                                                         </div>


            

            <div className="col-lg-12 col-md-6 col-sm-12">
              <div className="form-group">
                <label className="col-form-label ">Description</label>
                <textarea
                  className="form-control form-control-sm"
                  type="text"
                  id="description"
                  name="description"
                  value={values.description}
                  rows={8}
                  onChange={handleChange}
                />
                {touched.description && errors.description && (
                  <small className="text-danger">{errors.description}</small>
                )}
              </div>
            </div>



            <div className="col-sm-6">
                         <div className="form-group">
                          <label className="col-form-label ">Instagram Post Id</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            id="postId"
                            name="postId"
                            value={values.postId}
                            onChange={handleChange}
                            placeholder="Enter Post Id"
                          />

                          {touched.postId && errors.postId && (
                            <small className="text-danger">{errors.postId}</small>
                          )}
                        </div>
                      </div>

            <div className="col-sm-6">
              <div className="form-group">
                <label className="col-form-label ">Meta Title</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="meta_title"
                  name="meta_title"
                  value={values.meta_title}
                  onChange={handleChange}
                  placeholder="Enter meta title"
                />

                {touched.meta_title && errors.meta_title && (
                  <small className="text-danger">{errors.meta_title}</small>
                )}
              </div>
            </div>

            <div className="col-sm-6">
              <div className="form-group">
                <label className="col-form-label ">Meta Keyword</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="meta_keyword"
                  name="meta_keyword"
                  value={values?.meta_keyword}
                  onChange={handleChange}
                  placeholder="Enter meta title"
                />

                {touched.meta_keyword && errors.meta_keyword && (
                  <small className="text-danger">{errors.meta_keyword}</small>
                )}
              </div>
            </div>

            <div className="col-sm-6">
              <div className="form-group">
                <label className="col-form-label ">Meta Description</label>
                <textarea
                  type="text"
                  className="form-control form-control-sm"
                  id="meta_description"
                  name="meta_description"
                  value={values.meta_description}
                  onChange={handleChange}
                  placeholder="Enter meta description"
                />

                {touched.meta_description && errors.meta_description && (
                  <small className="text-danger">{errors.meta_description}</small>
                )}
              </div>
            </div>
            {catalogueData?.optionType === "Size" && sizedata.length > 0 && (
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="form-group">
                  <Sizemultiselect
                    sizedata={sizedata}
                    values={values?.sizes}
                    setFieldValue={setFieldValue}
                    sizeErrors={touched.sizes && errors.sizes ? errors.sizes : []}
                  />
                </div>
              </div>
            )}





            {keywords && keywords.length > 0 && (
  <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
    <label>Search Keywords</label>
    <div className=" keyword-container">
      {keywords.map((keyword, index) => (
        <span key={index} className="keyword-badge">
          {keyword}
        </span>
      ))}
    </div>
  </div>
)}



            <div className="w-100 d-flex justify-content-center align-items-center gap-3 mt-4">
              <button
                type="button"
                onClick={() => {
                  navigate(-1);
                }}
                className="btn btn-danger mr-3"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" />
                    Saving...
                  </>
                ) : (
                  "Save"
                )}
              </button>

            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CataloueProductUpdate;
